import { EditSensitiveWordsRequestParams, GetSensitiveWordsResultsRequestParams, GetSensitiveWordsSensitiveFilesRequestParams, ResponseDataSensitiveWordsFileView, SensitiveWordsListData } from '../service'

/** vue-i18n 文案键（配合 t() 使用，命名空间 sensitiveFileScanning） */
export type SensitiveFileScanningMsgKey = `sensitiveFileScanning.${string}`

export enum ScanState {
  Scanning = 1,
  Scanned = 2,
  ScannedFinish = 3,
}
export type ScanStateKeys = keyof typeof ScanState
export type ScanStateValues = (typeof ScanState)[ScanStateKeys]

export const ScanStateText: { [P in ScanStateValues]: SensitiveFileScanningMsgKey } = {
  1: 'sensitiveFileScanning.scanStateScanning',
  2: 'sensitiveFileScanning.scanStateScanned',
  3: 'sensitiveFileScanning.scanStateFailed',
}

export enum DataTypeSensitive {
  Customize = 1,
  FinancialBudget = 2,
  SalaryBonus = 3,
  EmployeeInformation = 4,
  TechnicalSolution = 5,
}
export type DataTypeSensitiveKeys = keyof typeof DataTypeSensitive
export type DataTypeSensitiveValues = (typeof DataTypeSensitive)[DataTypeSensitiveKeys]

/** 内置敏感数据类型展示文案键（自定义类型用 row.name） */
export const DataTypeSensitiveText: { [P in DataTypeSensitiveValues]: SensitiveFileScanningMsgKey } = {
  1: 'sensitiveFileScanning.dataTypeBuiltinCustomize',
  2: 'sensitiveFileScanning.dataTypeBuiltinFinancialBudget',
  3: 'sensitiveFileScanning.dataTypeBuiltinCompanyEmployeeInfo',
  4: 'sensitiveFileScanning.dataTypeBuiltinSalaryBonus',
  5: 'sensitiveFileScanning.dataTypeBuiltinTechnicalSolution',
}

export enum SensitiveWordType {
  SensitiveWord = 1,
  ScannedFile = 2,
}
export type SensitiveWordTypeKeys = keyof typeof SensitiveWordType
export type SensitiveWordTypeValues = (typeof SensitiveWordType)[SensitiveWordTypeKeys]

export const SensitiveWordTypeText: { [P in SensitiveWordTypeValues]: SensitiveFileScanningMsgKey } = {
  1: 'sensitiveFileScanning.sensitiveWord',
  2: 'sensitiveFileScanning.sensitiveWordTypeScannedFile',
}

export type ExcludeRequestParams = Exclude<keyof GetSensitiveWordsResultsRequestParams, 'limit' | 'page'>
export type QueryFormType = Partial<GetSensitiveWordsResultsRequestParams>
export type ExcludeRequestParamsFileView = Exclude<keyof ResponseDataSensitiveWordsFileView, 'limit' | 'page'>
export type QueryFormTypeFileView = Partial<ResponseDataSensitiveWordsFileView>
export type QueryFormFileViewType = Partial<ResponseDataSensitiveWordsFileView>

export type ExcludeRequestParamsSensitiveFileDetail = Exclude<keyof GetSensitiveWordsSensitiveFilesRequestParams, 'limit' | 'page'>
export type QueryFormTypeSensitiveFileDetail = Partial<GetSensitiveWordsSensitiveFilesRequestParams>

export type EditSensitiveWordsRequestParamsForm = Partial<EditSensitiveWordsRequestParams>

export type ExcludeEditSensitiveWordsRequestParams = Exclude<keyof EditSensitiveWordsRequestParams, 'state'>

/** 文件格式大类 Tab 文案键（与 mockExts type 一致） */
export const fileTypeListLabel: { [k: number]: SensitiveFileScanningMsgKey } = {
  1: 'sensitiveFileScanning.fileType1',
  2: 'sensitiveFileScanning.fileType2',
  3: 'sensitiveFileScanning.fileType3',
  4: 'sensitiveFileScanning.fileType4',
  5: 'sensitiveFileScanning.fileType5',
}

/** 外发通道类别文案键（策略里 way 字段用 t() 展开后的文案做行匹配） */
export const channelTypeI18nKey: Record<1 | 2 | 3 | 4, SensitiveFileScanningMsgKey> = {
  1: 'sensitiveFileScanning.channelOutboundByNetwork',
  2: 'sensitiveFileScanning.channelOutboundByIm',
  3: 'sensitiveFileScanning.channelOutboundByNetdisk',
  4: 'sensitiveFileScanning.channelOutboundByDevice',
}

export enum SensitiveStateType {
  Allowed = 1,
  Rejected = 2,
}
export type SensitiveStateTypeKeys = keyof typeof SensitiveStateType
export type SensitiveStateTypeValues = (typeof SensitiveStateType)[SensitiveStateTypeKeys]

export const SensitiveStateTypeText: { [P in SensitiveStateTypeValues]: SensitiveFileScanningMsgKey } = {
  1: 'sensitiveFileScanning.wordStateEnabled',
  2: 'sensitiveFileScanning.wordStateDisabled',
}

export const mockExts = [
  {
    type: 1,
    data: ['.doc', '.docx', '.xlsx', '.xls', '.csv', '.rtf', '.ppt', '.pptx', '.pdf', '.txt'].map(item => ({ name: item, value: item })),
  },
  {
    type: 2,
    data: ['.z', '.gz', '.zip', '.rar', '.7z'].map(item => ({ name: item, value: item })),
  },
  {
    type: 3,
    data: ['.mp3', '.mp4', '.rm', '.mov', '.wav', '.avi', '.rmvb', '.MKV', '.FLV', '.WMV'].map(item => ({ name: item, value: item })),
  },
  {
    type: 4,
    data: ['.gif', '.png', '.bmp', '.pic', '.tif', '.jpg', '.jpeg', '.psd', '.TGA', '.raw'].map(item => ({ name: item, value: item })),
  },
  {
    type: 5,
    data: ['.dwg', '.obj', '.stl', '.gltf', '.step', '.fbx', '.3ds', '.glb'].map(item => ({ name: item, value: item })),
  },
]
